import {
  CardActionArea,
  CircularProgress,
  ClickAwayListener,
  Container,
  Menu,
  MenuItem,
  Grid,
  Box,
  Card,
  Tooltip,
  IconButton,
  Badge,
  Chip,
  CardContent,
  CardMedia,
  Button,
  Typography,
  Stack,
} from "@mui/material";
import {
  BusinessCenter as BusinessCenterIcon,
  LogoutOutlined,
  LoginOutlined,
  Sms as SmsIcon,
  CheckCircle as CheckCircleIcon,
  ArrowForwardIos as ArrowForwardIosIcon,
  ArrowBackIos as ArrowBackIosIcon,
  TouchApp as TouchAppIcon,
  FilterList as FilterListIcon,
  AccountCircle as AccountCircleIcon,
  Add as AddIcon,
  CalendarMonth as CalendarMonthIcon,
} from "@mui/icons-material";

import App from "./App";

import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { DateTime } from "luxon";

import { useContext, useEffect, useState, useRef } from "react";

import ImageGallery from "./ImageGallery";
import _ from "lodash";

import { AuthContext } from "../index";
import { GlobalDataContext } from "../index";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";

import "./MainScreen.css";

import ItemsListV2 from "./ItemsListV2";
import { getImage, getImageV2, getImageV3 } from "../utils/getImage";

import {
  getHourMinutes,
  getDay,
  today,
  startOfDay,
  endOfDay,
} from "../utils/dateTime";
import { default as FilterInfoV2 } from "./InfoV2";
import { default as ChatModal } from "./InfoV2";
import { default as AuthModal } from "./InfoV2";
import { default as Features } from "./Features";
import Chat from "./Chat";
import React from "react";
import SwipableImageCarousel from "./SwipableImageCarousel";
import BIM_LOGO from "../images/bim_logo_100.png";
import AuthBySMSForm from "./AuthBySMSForm";

function MainScreen() {
  const { filters, setFilters, messages, handleSendMessage } =
    useContext(GlobalDataContext);
  const { id, userId, phoneNumber, onLogin, onLogout } =
    useContext(AuthContext);

  const navigate = useNavigate();
  const [accountRef, setAccountRef] = React.useState(null);
  const accountMenuRef = React.useRef(null);
  const [accountMenuOpen, setAccountMenuOpen] = useState(false);

  const handleOpenUserMenu = (event) => {
    setAccountRef(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAccountRef(null);
  };

  const _getValueFromFilter = (type, filters) => {
    if (!filters || !filters.filter((f) => f.type == type).length) {
      return null;
    }

    return filters.filter((f) => f.type == type)[0].value;
  };

  const [services, setServices] = useState({
    isLoaded: false,
    data: [],
    grouped: [],
  });
  const [locations, setLocations] = useState({
    isLoaded: false,
    data: [],
  });
  const [serviceTemplates, setServiceTemplates] = useState({
    isLoaded: false,
    data: [],
  });
  const DEFAULT_FILTER_INFO_STATE = {
    open: false,
    filters: [...filters],
    calendar: {
      open: false,
    },
  };
  const [filterInfo, setFilterInfo] = useState(DEFAULT_FILTER_INFO_STATE);

  const DEFAULT_CHAT_STATE = {
    open: false,
    isLoading: false,
    data: [],
  };
  const [chat, setChat] = useState(DEFAULT_CHAT_STATE);

  const [chatDetailed, setChatDetailed] = useState(null);

  const DEFAULT_SERVICE_CONFIRM_STATE = {
    open: false,
    inProgress: false,
    text: "",
    serviceId: "",
  };
  const [serviceConfirm, setServiceConfirm] = useState(
    DEFAULT_SERVICE_CONFIRM_STATE,
  );

  const DEFAULT_SERVICE_CONFIRM_STATUS_STATE = {
    open: false,
    isError: false,
  };

  const DEFAULT_REDIRECT_TO_AUTH_STATE = {
    open: false,
  };

  const [serviceConfirmStatus, setServiceConfirmStatus] = useState(
    DEFAULT_SERVICE_CONFIRM_STATUS_STATE,
  );
  const [redirectToAuth, setRedirectToAuth] = useState(
    DEFAULT_REDIRECT_TO_AUTH_STATE,
  );

  const groupServicesByServiceTemplate = (funcServices = []) => {
    const list = funcServices.reduce((acc, curr) => {
      const idx = acc.findIndex(
        (it) => it.serviceTemplate.id === curr.serviceTemplate.id,
      );

      if (idx != -1) {
        const dateIdx = acc[idx].dates.findIndex(
          (d) => d?.date == getDay(curr?.timeFrame?.from),
        );

        if (curr?.features) {
          acc[idx].features.push(curr?.features);
        }

        if (dateIdx != -1) {
          const locationIdx = acc[idx].dates[dateIdx].locations.findIndex(
            (l) => l.id == curr.location.id,
          );

          if (locationIdx != -1) {
            acc[idx].dates[dateIdx].locations[locationIdx].timeFrames.push(
              curr.timeFrame,
            );
          } else {
            acc[idx].dates[dateIdx].locations.push({
              ...curr.location,
              timeFrames: [curr.timeFrame],
            });
          }
        } else {
          acc[idx].dates.push({
            date: getDay(curr?.timeFrame?.from),
            locations: [{ ...curr.location, timeFrames: [curr.timeFrame] }],
          });
        }
      } else {
        acc.push({
          serviceTemplate: curr.serviceTemplate,
          features: curr?.features ? [curr.features] : [],
          dates: [
            {
              date: getDay(curr?.timeFrame?.from),
              locations: [{ ...curr.location, timeFrames: [curr.timeFrame] }],
            },
          ],
        });
      }

      return acc;
    }, []);

    return list;
  };

  async function loadChats() {
    let url = `/api/v1/chats/get-chats`;

    setChat((prevState) => ({ ...prevState, isLoading: true }));

    try {
      const resp = await axios.post(url, {});
      setChat({ isLoading: false, data: resp.data });
      setChatDetailed(resp?.data?.[0]);
    } catch (err) {
      throw err;
    }
  }

  useEffect(() => {
    loadChats();
  }, []);

  async function loadServices() {
    try {
      const resp = await axios.post(`/api/v1/services/get`, {
        timeFrame: {
          from: _getValueFromFilter("timeFrameFrom", filters),
          to: _getValueFromFilter("timeFrameTo", filters),
        },
      });

      setServices({
        isLoaded: true,
        data: resp.data,
      });
    } catch (err) {
      //noop
    }
  }

  useEffect(() => {
    if (services.isLoaded) {
      return;
    }

    loadServices();
  }, [services.isLoaded]);

  const [showCalendar, setShowCalendar] = useState(false);

  const _handleFilterModalOpen = () => {
    //todo change
    setFilterInfo((prevState) => ({
      ...prevState,
      open: true,
    }));
  };

  const _handleFilterModalClose = () => {
    setFilterInfo((prevState) => ({
      ...prevState,
      open: false,
    }));
  };

  const handleChatOpen = () => {
    setChat((prevState) => ({ ...prevState, open: true }));
  };
  const handleChatClose = () => {
    setChat((prevState) => ({ ...prevState, open: false }));
  };

  const _handleLocationTimeClick = (
    serviceTemplateId,
    locationId,
    timeFrameFrom,
  ) => {
    if (!userId) {
      // setRedirectToAuth(prevState => ({...prevState, open: true}));
      handleAuthModalOpen();
      setServiceDetailed(null);
      return;
    }

    const service = services?.data?.filter(
      (service) =>
        service?.serviceTemplate?.id == serviceTemplateId &&
        service?.location?.id == locationId &&
        service?.timeFrame?.from == timeFrameFrom,
    )[0];

    setServiceConfirm({
      // open: true,
      serviceId: service?.id,
      text: `
            ${service?.serviceTemplate?.title}
            ${getDay(service?.timeFrame?.from)}, c  
            ${getHourMinutes(service?.timeFrame?.from)} по  
            ${getHourMinutes(service?.timeFrame?.to)} \n
            по адресу: ${service?.location?.address}
            `,
      customizations: service?.customizations,
    });
  };

  const _handleServiceBook = async ({ serviceId, customizations }) => {
    if (!serviceId) {
      setServiceConfirm(DEFAULT_SERVICE_CONFIRM_STATE);
      setServiceConfirmStatus({ open: true, isError: true });
    }

    try {
      setServiceConfirm((prevState) => ({ ...prevState, inProgress: true }));

      const resp = await axios.put(`/api/v1/services`, {
        id: serviceId,
        client: {
          id: id,
        },
        customizations: customizations,
      });

      setServiceConfirm(DEFAULT_SERVICE_CONFIRM_STATE);
      setServiceConfirmStatus({ open: true, isError: false });
      setServiceDetailed(null);
      setServices((prevState) => ({ ...prevState, isLoaded: false }));
    } catch (err) {
      setServiceConfirm(DEFAULT_SERVICE_CONFIRM_STATE);
      setServiceConfirmStatus({ open: true, isError: true });
    }
  };

  // todo finished here
  const _getCentralChip = () => {
    const from = getDay(_getValueFromFilter("timeFrameFrom", filters));
    const to = getDay(_getValueFromFilter("timeFrameTo", filters));

    const element = (
      <Stack
        sx={{
          pt: "2px",
          pb: "2px",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          width: "100%",
        }}
        display={"column"}
      >
        <Box
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            display: "flex",
            width: "100%",
          }}
        >
          <Box
            sx={{
              width: "24px",
              borderRadius: "50%",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={(e) => {
              e.stopPropagation();
              plusDaysToDate(-1);
            }}
          >
            {getDay(today()) !=
              getDay(_getValueFromFilter("timeFrameFrom", filters)) &&
            getDay(_getValueFromFilter("timeFrameFrom", filters)) ==
              getDay(_getValueFromFilter("timeFrameTo", filters)) ? (
              <ArrowBackIosIcon
                fontSize={"small"}
                sx={{
                  color: "gray",
                  ml: 1,
                  display: "block",
                }}
              />
            ) : null}
          </Box>
          <Typography fontSize={"12px"} sx={{ color: "gray" }}>
            <CalendarMonthIcon
              sx={{ fontSize: "12px", fontWeight: "bold", pr: "2px" }}
            />
            {getDay(_getValueFromFilter("timeFrameFrom", filters))}
            {from != to ? <>&nbsp;&ndash;&nbsp;</> : null}
            {from != to
              ? getDay(_getValueFromFilter("timeFrameTo", filters))
              : null}
          </Typography>
          <Box
            sx={{
              width: "24px",
              borderRadius: "50%",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={(e) => {
              e.stopPropagation();
              plusDaysToDate(1);
            }}
          >
            {getDay(_getValueFromFilter("timeFrameFrom", filters)) ==
            getDay(_getValueFromFilter("timeFrameTo", filters)) ? (
              <ArrowForwardIosIcon
                fontSize={"small"}
                sx={{
                  color: "gray",
                  mr: 1,
                  display: "block",
                }}
              />
            ) : null}
          </Box>
        </Box>
      </Stack>
    );

    return (
      <Box
        sx={{
          display: "flex",
          borderRadius: "30px",
          border: "1px solid #ddd",
          justifyContent: "center",
          alignItems: "center",
          p: "5px",
          boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
        }}
        // onClick={() => {
        //    setFilterInfo(prevState => ({...prevState, open: true}));
        // }}
      >
        {element}
      </Box>
    );
  };

  const handleDatePickV2 = (newDate, type) => {
    setFilterInfo((prevState) => {
      let nextFilters = [...(prevState?.filters ?? [])];

      if (type == "from") {
        const ixFrom = nextFilters.findIndex(
          (fltr) => fltr.type == "timeFrameFrom",
        );
        if (ixFrom != -1) {
          nextFilters.splice(ixFrom, 1);
        }

        nextFilters.push({
          type: "timeFrameFrom",
          value: startOfDay(newDate / 1000),
        });
      }

      if (type == "to") {
        const ixTo = nextFilters.findIndex(
          (fltr) => fltr.type == "timeFrameTo",
        );
        if (ixTo != -1) {
          nextFilters.splice(ixTo, 1);
        }

        nextFilters.push({
          type: "timeFrameTo",
          value: endOfDay(newDate / 1000),
        });
      }

      return {
        ...prevState,
        calendar: { ...prevState?.calendar, openFrom: false, openTo: false },
        filters: [...nextFilters],
      };
    });
  };

  const plusDaysToDate = (day) => {
    day = parseInt(day);
    setFilters((prevState) => {
      const nextFilters = [...filters];
      let newDateFrom = 0;
      const ixFrom = nextFilters.findIndex(
        (fltr) => fltr.type == "timeFrameFrom",
      );
      if (ixFrom != -1) {
        newDateFrom = new Date(parseInt(nextFilters[ixFrom].value * 1000));
        newDateFrom.setDate(newDateFrom.getDate() + day);

        nextFilters.splice(ixFrom, 1);
      }

      let newDateTo = 0;
      const ixTo = nextFilters.findIndex((fltr) => fltr.type == "timeFrameTo");
      if (ixTo != -1) {
        newDateTo = new Date(parseInt(nextFilters[ixTo].value * 1000));
        newDateTo.setDate(newDateTo.getDate() + day);

        nextFilters.splice(ixTo, 1);
      }

      return [
        ...nextFilters,
        { type: "timeFrameFrom", value: startOfDay(newDateFrom / 1000) },
        { type: "timeFrameTo", value: endOfDay(newDateTo / 1000) },
      ];
    });
  };

  useEffect(() => {
    setServices((prevState) => ({ ...prevState, isLoaded: false }));
    setFilterInfo(DEFAULT_FILTER_INFO_STATE);
  }, [filters]);

  const handleDiscountPickV2 = () => {
    setFilterInfo((prevState) => {
      const nextFilters = [...(prevState?.filters ?? [])];
      const ix = nextFilters.findIndex((fltr) => fltr.type == "discount");
      if (ix != -1) {
        const currValue = nextFilters[ix].value;
        nextFilters.splice(ix, 1);
        nextFilters.push({ type: "discount", value: !currValue });
      } else {
        nextFilters.push({ type: "discount", value: true });
      }

      return {
        ...prevState,
        filters: [...nextFilters],
      };
    });
  };

  const DEFAULT_AUTH_MODAL_STATE = {
    open: false,
  };
  const [authModal, setAuthModal] = useState(DEFAULT_AUTH_MODAL_STATE);

  const handleAuthModalOpen = () => {
    setAuthModal((prevState) => ({ ...prevState, open: true }));
  };

  const handleAuthModalClose = () => {
    setAuthModal((prevState) => ({ ...prevState, open: false }));
  };

  const isPickedDateTime = (locationItem, timeFrame) => {
    const filteredServices = services?.data?.filter(
      (service) => service?.id == serviceConfirm?.serviceId,
    );
    if (
      filteredServices?.length &&
      filteredServices[0].serviceTemplate?.id ==
        serviceDetailed?.serviceTemplate?.id &&
      locationItem?.id == filteredServices[0]?.location?.id &&
      timeFrame?.from == filteredServices[0]?.timeFrame?.from
    ) {
      return true;
    }
    return false;
  };

  const [serviceDetailed, setServiceDetailed] = useState(null);
  useEffect(() => {
    if (serviceDetailed == null) {
      setServiceConfirm(DEFAULT_SERVICE_CONFIRM_STATUS_STATE);
    }
  }, [serviceDetailed]);

  const [locationDetailed, setLocationDetailed] = useState(null);
  const [mapDetailed, setMapDetailed] = useState(null);
  const [serviceBook, setServiceBook] = useState({ isLoaded: true });
  const datePlaceSection = useRef(null);

  const [button, setButton] = useState({ text: "", loading: false });
  let handleButtonClick = () => {};
  let setButtonClick = (action) => {
    handleButtonClick = action;
  };

  return (
    <App
      top={
        <Stack
          direction={"row"}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pl: 4,
            pr: 4,
            backgroundColor: "#fcfcfc",
            // boxShadow: 'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
            boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
            isolation: "isolate",
          }}
        >
          <Container
            maxWidth={"lg"}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                height: "25px",
                "&:hover": { cursor: "pointer" },
              }}
              component={"img"}
              onClick={() => navigate("/")}
              src={BIM_LOGO}
            />
            <Stack
              spacing={3}
              direction="row"
              sx={{
                p: 2,
                display: "flex",
                // flexGrow: 0,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Box>
                <Badge
                  badgeContent={
                    filters.filter((it) => it.type != "timeFrameTo").length
                  }
                  color={"primary"}
                  onClick={_handleFilterModalOpen}
                  sx={{
                    "&:hover": { cursor: "pointer" },
                    // borderRadius: '15px',
                    // p: '2px',
                    // border: "1px solid gray"
                  }}
                >
                  <Chip
                    sx={{ fontSize: "10px" }}
                    label={"Фильтры"}
                    onClick={_handleFilterModalOpen}
                  ></Chip>
                  {/*<FilterListIcon*/}
                  {/*    sx={{color: 'gray'}}*/}
                  {/*/>*/}
                </Badge>
              </Box>
              {_getCentralChip()}
            </Stack>
            <Box>
              <Tooltip title="">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <AccountCircleIcon
                    sx={{
                      fontSize: "30px",
                      color: "#e3e3e3",
                      "&:hover": { cursor: "pointer" },
                    }}
                  />
                </IconButton>
              </Tooltip>
              <Menu
                anchorEl={accountRef}
                open={Boolean(accountRef)}
                sx={{ mt: "45px" }}
                variant={"body2"}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                onClose={handleCloseUserMenu}
              >
                {userId ? (
                  <MenuItem>
                    <Stack
                      variant={"body2"}
                      direction={"row"}
                      alignItems={"center"}
                      sx={{ justifyContent: "center", alignItems: "flex-end" }}
                      onClick={() => {
                        navigate("/visits");
                      }}
                      // onClick={() => { setServiceList(prevState => ({...prevState, open: true}))}}
                    >
                      <Box>
                        <BusinessCenterIcon
                          fontSize="inherit"
                          verticalAlign={"center"}
                          // variant={"body2"}
                          sx={{
                            // fontSize: "12px",
                            pr: 1,
                            // transform: "translateY(-4px)",
                            color: "rgb(0 0 0/0.75)",
                          }}
                        />
                      </Box>
                      <Typography
                        // variant={'body2'}
                        // fontSize={}

                        sx={{ color: "rgb(0 0 0/ 0.7)" }}
                      >
                        Мои визиты
                      </Typography>
                    </Stack>
                  </MenuItem>
                ) : null}
                {userId ? (
                  <MenuItem>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      onClick={() => {
                        handleChatOpen();
                        handleCloseUserMenu();
                      }}
                    >
                      <SmsIcon
                        fontSize="inherit"
                        sx={{
                          pr: 1,
                          color: "rgb(0 0 0/0.75)",
                        }}
                      />
                      <Typography sx={{ color: "rgb(0 0 0/ 0.7)" }}>
                        Чаты
                      </Typography>
                    </Stack>
                  </MenuItem>
                ) : null}
                {userId ? (
                  <MenuItem>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      onClick={onLogout}
                    >
                      <LogoutOutlined
                        fontSize="inherit"
                        sx={{
                          pr: 1,
                          color: "rgb(0 0 0/0.75)",
                        }}
                      />
                      <Typography sx={{ color: "rgb(0 0 0/ 0.7)" }}>
                        Выйти
                      </Typography>
                    </Stack>
                  </MenuItem>
                ) : null}
                {!userId ? (
                  <MenuItem>
                    <Stack
                      direction={"row"}
                      alignItems={"center"}
                      onClick={() => {
                        handleAuthModalOpen();
                        handleCloseUserMenu();
                      }}
                    >
                      <LoginOutlined
                        fontSize="inherit"
                        sx={{
                          fontSize: "14px",
                          pr: 1,
                          color: "rgb(0 0 0/ 0.5)",
                        }}
                      />
                      <Typography sx={{ color: "rgb(0 0 0/ 0.7)" }}>
                        Войти
                      </Typography>
                    </Stack>
                  </MenuItem>
                ) : null}
              </Menu>
            </Box>
          </Container>
        </Stack>
      }
    >
      <Container maxWidth={"lg"} sx={{ pt: 4 }}>
        <ItemsListV2
          sxExtra={{
            minWidth: {
              xs: "90%",
              sm: "80%",
              md: "60%",
            },
          }}
          itemsLoading={!services.isLoaded}
          closeDetailed={() => {
            setServiceDetailed(null);
          }}
          items={
            services?.data?.length ? (
              groupServicesByServiceTemplate(services.data).map((item) => (
                <Grid item md={3} sm={4}>
                  <Card
                    // elevation={1}
                    sx={{
                      display: "flex",
                      border: "none",
                      "&:focus": { outline: "none" },
                      "&:hover": { background: "transparent" },
                      p: 1,
                    }}
                    onClick={() => {
                      setServiceDetailed(item);
                    }}
                  >
                    <CardActionArea
                      disableRipple
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                      }}
                      onClick={() => {
                        setServiceDetailed(item);
                      }}
                    >
                      <Box
                        sx={{
                          borderRadius: "15px",
                          overflow: "hidden",
                        }}
                      >
                        <SwipableImageCarousel
                          images={_.slice(item?.serviceTemplate?.images, 0, 1)}
                          aspectRatio={"1/1"}
                          getImage={getImage}
                          imageUrls={_.slice(
                            item?.serviceTemplate?.images?.map((it) =>
                              getImageV2(it?.id),
                            ),
                            0,
                            1,
                          )}
                        />
                      </Box>
                      <CardContent
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-start",
                          p: 0,
                          pt: 1,
                          // height: '100%',
                          marginBottom: 0,
                          width: "100%",
                        }}
                      >
                        <Stack
                          sx={{
                            height: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <Stack>
                            <Stack
                              direction={"row"}
                              justifyContent={"space-between"}
                            >
                              <Typography
                                sx={{ fontSize: "15px", fontWeight: "bold" }}
                                align={"left"}
                              >
                                {" "}
                                {item?.serviceTemplate?.title}
                              </Typography>
                              <Typography
                                sx={{ fontSize: "14px" }}
                                align={"left"}
                              >
                                {" "}
                                {item?.serviceTemplate?.price}{" "}
                                <span>&#8381;</span>
                              </Typography>
                            </Stack>

                            <Typography
                              sx={{ fontSize: "10px", color: "gray" }}
                              align={"left"}
                            >
                              {item?.serviceTemplate?.descriptionShort}
                            </Typography>
                            <Typography
                              sx={{ mt: 1, fontSize: "10px" }}
                              align={"left"}
                            >
                              {`${item?.dates
                                ?.reduce((acc, curr) => {
                                  for (
                                    let i = 0;
                                    i < curr.locations.length;
                                    i++
                                  ) {
                                    var metromatch =
                                      curr.locations[i]?.address?.match(
                                        /\(([^)]+)\)/,
                                      );
                                    if (!metromatch) continue;

                                    if (
                                      acc.findIndex(
                                        (metro) => metro == metromatch[1],
                                      ) == -1
                                    ) {
                                      acc.push(metromatch[1]);
                                    }
                                  }

                                  return acc;
                                }, [])
                                .reduce((acc, curr) => {
                                  if (acc.length == 2) {
                                    acc.push(" еще 1");
                                  } else if (acc.length > 2) {
                                    acc[2] = ` еще ${acc.length - 2}`;
                                  } else {
                                    acc.push(curr);
                                  }
                                  return acc;
                                }, [])
                                .join("  ")}`}
                            </Typography>
                          </Stack>
                        </Stack>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))
            ) : (
              <Typography sx={{ color: "gray", fontSize: "14px" }}>
                Все массажи на эти даты уже разобрали
              </Typography>
            )
          }
          itemDetailed={
            serviceDetailed ? (
              // procedure detailed
              <ClickAwayListener onClickAway={() => setServiceDetailed(null)}>
                <Container maxWidth={"md"}>
                  <Box
                    sx={{
                      justifyContent: "space-between",
                      overflowY: "auto",
                      height: "100%",
                    }}
                  >
                    <ImageGallery
                      imageUrls={serviceDetailed?.serviceTemplate?.images?.map(
                        (it) => getImageV2(it?.id),
                      )}
                    />
                    <Grid container spacing={2}>
                      <Grid item xs={8}>
                        <Typography
                          align="left"
                          sx={{ pt: 2, fontSize: "16px" }}
                        >
                          {" "}
                          {serviceDetailed?.serviceTemplate?.title}{" "}
                        </Typography>
                        <Typography
                          align="left"
                          sx={{ pt: 1, fontSize: "10px", color: "gray" }}
                        >
                          {" "}
                          {serviceDetailed?.serviceTemplate?.description}{" "}
                        </Typography>
                        {serviceDetailed?.features?.length ? (
                          <Features
                            sxExtra={{ mt: 4 }}
                            features={serviceDetailed?.features}
                          />
                        ) : null}
                        <Typography
                          ref={datePlaceSection}
                          sx={{ pt: 6, fontSize: "12px" }}
                          align={"left"}
                        >
                          Место и время
                        </Typography>

                        <CardContent
                          sx={{
                            position: "relative",
                            backgroundColor: "#fff",
                            // borderTopLeftRadius: '25px',
                            // borderTopRightRadius: '25px',
                          }}
                        >
                          <ItemsListV2
                            sxExtra={{
                              minWidth: {
                                xs: "90%",
                                sm: "80%",
                                md: "60%",
                              },
                              minHeight: "80%",
                            }}
                            items={serviceDetailed?.dates
                              .sort(
                                (dateItemFirst, dateItemSecond) =>
                                  dateItemFirst?.locations[0].timeFrame?.from -
                                  dateItemSecond.timeFrame?.from,
                              )
                              .map((dateItem) => (
                                <Stack sx={{ width: "100%" }}>
                                  <Typography
                                    sx={{ pb: 1 }}
                                    fontSize={"16px"}
                                    color={"gray"}
                                    align={"left"}
                                  >
                                    {dateItem?.date}
                                  </Typography>
                                  {dateItem?.locations.map((locationItem) => (
                                    <Box
                                      sx={{
                                        borderRadius: "24px",
                                        boxShadow:
                                          "rgba(0, 0, 0, 0.1) 0px 4px 12px",
                                      }}
                                      onClick={() => {
                                        setLocationDetailed(locationItem);
                                      }}
                                    >
                                      <CardActionArea
                                        disableRipple
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-start",
                                          alignItems: "flex-start",
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            position: "relative",
                                            width: 120,
                                            height: 120,
                                            m: "2px",
                                            mr: 2,
                                          }}
                                        >
                                          <CardMedia
                                            component="img"
                                            sx={{
                                              width: 120,
                                              height: 120,
                                              borderRadius: "24px",
                                            }}
                                            image={getImageV3(
                                              _.nth(
                                                locationItem?.images?.map(
                                                  (im) => im?.id,
                                                ),
                                                1,
                                              ),
                                            )}
                                            alt=""
                                          />
                                          <TouchAppIcon
                                            sx={{
                                              position: "absolute",
                                              bottom: "5px",
                                              left: "5px",
                                              color: "white",
                                            }}
                                          />
                                        </Box>
                                        <CardContent
                                          sx={{
                                            pl: 0,
                                            pt: 1,
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "flex-start",
                                            height: "100%",
                                            minWidth: 0,
                                          }}
                                        >
                                          <Typography
                                            fontSize={"12px"}
                                            color={"gray"}
                                          >
                                            {locationItem?.title}
                                          </Typography>
                                          <Typography
                                            fontSize={"10px"}
                                            color={"gray"}
                                            sx={{ pb: 1 }}
                                          >
                                            {locationItem?.address?.match(
                                              /\(([^)]+)\)/,
                                            )
                                              ? locationItem?.address?.match(
                                                  /\(([^)]+)\)/,
                                                )[1]
                                              : null}
                                          </Typography>
                                          {/*<Grid item size={4}>*/}
                                          {/*    {*/}
                                          <Stack
                                            useFlexGap
                                            sx={{
                                              flexWrap: "nowrap",
                                              justifyContent: "flex-start",
                                              alignItems: "center",
                                              whiteSpace: "nowrap",
                                              overflowX: "auto",
                                              width: "100%",
                                              pr: 1,
                                              "&::-webkit-scrollbar": {
                                                display: "none",
                                              },
                                            }}
                                            direction={"row"}
                                            spacing={1}
                                          >
                                            {locationItem?.timeFrames?.map(
                                              (tf) => (
                                                <Stack
                                                  direction={"row"}
                                                  onClick={(event) => {
                                                    event.stopPropagation();
                                                    event.preventDefault();

                                                    if (
                                                      isPickedDateTime(
                                                        locationItem,
                                                        tf,
                                                      )
                                                    ) {
                                                      setServiceConfirm(
                                                        DEFAULT_SERVICE_CONFIRM_STATE,
                                                      );
                                                    } else {
                                                      _handleLocationTimeClick(
                                                        serviceDetailed
                                                          ?.serviceTemplate?.id,
                                                        locationItem?.id,
                                                        tf.from,
                                                      );
                                                    }
                                                  }}
                                                  data-test-id={"btn-time"}
                                                  sx={{
                                                    flexShrink: 0,
                                                    border: `1px solid ${isPickedDateTime(locationItem, tf) ? "#76c6ff" : "#e3e3e3"}`,
                                                    backgroundColor: "#f3f3f3",
                                                    borderRadius: "25px",
                                                    justifyContent:
                                                      "space-between",
                                                    alignItems: "center",
                                                    p: "4x",
                                                    pt: "10px",
                                                    pb: "10px",
                                                    pl: "10px",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  <Typography
                                                    sx={{
                                                      fontSize: "12px",
                                                      mr: "2px",
                                                      flexWrap: "nowrap",
                                                    }}
                                                  >
                                                    {getHourMinutes(tf.from) +
                                                      " - " +
                                                      getHourMinutes(tf.to)}
                                                  </Typography>
                                                  {isPickedDateTime(
                                                    locationItem,
                                                    tf,
                                                  ) ? (
                                                    <CheckCircleIcon
                                                      sx={{
                                                        color: "#76c6ff",
                                                        fontSize: "24px",
                                                        mr: "4px",
                                                        ml: "4px",
                                                      }}
                                                    />
                                                  ) : (
                                                    <AddIcon
                                                      sx={{
                                                        border:
                                                          "1px solid #a7a7a7",
                                                        mr: "4px",
                                                        ml: "4px",
                                                        borderRadius: "50%",
                                                        color: "#a7a7a7",
                                                        fontSize: "20px",
                                                      }}
                                                    />
                                                  )}
                                                </Stack>
                                              ),
                                            )}
                                          </Stack>
                                        </CardContent>
                                      </CardActionArea>
                                    </Box>
                                  ))}
                                </Stack>
                              ))}
                            itemsLoading={false}
                            closeDetailed={() => {
                              setLocationDetailed(null);
                            }}
                            itemDetailed={
                              locationDetailed ? (
                                <Container maxWidth={"md"}>
                                  <Box
                                    sx={{
                                      justifyContent: "space-between",
                                      overflowY: "auto",
                                      height: "100%",
                                      pb: 3,
                                    }}
                                  >
                                    <Typography
                                      align="center"
                                      sx={{ pb: 2, fontSize: "20px" }}
                                    >
                                      {" "}
                                      {locationDetailed?.title}{" "}
                                    </Typography>
                                    <Typography
                                      sx={{ fontSize: "12px", color: "gray" }}
                                      align="left"
                                    >
                                      {" "}
                                      {locationDetailed?.description}{" "}
                                    </Typography>
                                    <Typography
                                      sx={{ pb: 1, pt: 2, fontSize: "12px" }}
                                      align="left"
                                    >
                                      {" "}
                                      Адрес{" "}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontSize: "10px",
                                        color: "gray",
                                        pb: 1,
                                      }}
                                      align="left"
                                    >
                                      {" "}
                                      {locationDetailed?.address}{" "}
                                    </Typography>
                                    <Box
                                      sx={{
                                        borderRadius: "15px",
                                        overflow: "hidden",
                                        height: "300px",
                                      }}
                                    >
                                      <iframe
                                        src={locationDetailed?.mapUrl}
                                        width="100%"
                                        height="100%"
                                        frameBorder="0"
                                      ></iframe>
                                    </Box>
                                  </Box>
                                </Container>
                              ) : null
                            }
                          />
                        </CardContent>
                      </Grid>
                      <Grid item xs={4}>
                        <Box>
                          <Stack
                            sx={{
                              p: 2,
                              justifyContent: "flex-start",
                              alignItems: "flex-start",
                            }}
                            spacing={2}
                          >
                            <Stack
                              sx={{
                                flex: "1 1 50%",
                                maxWidth: "300px",
                              }}
                            >
                              <Typography
                                sx={{ fontSize: "16px" }}
                                align={"left"}
                              >
                                {" "}
                                {serviceDetailed?.serviceTemplate?.price}{" "}
                                <span>&#8381;</span>
                              </Typography>
                              {serviceConfirm?.serviceId ? (
                                <Typography
                                  sx={{ fontSize: "10px", color: "gray" }}
                                >
                                  {" "}
                                  {serviceConfirm.text}{" "}
                                </Typography>
                              ) : (
                                <Typography
                                  sx={{ fontSize: "8px", color: "gray" }}
                                >
                                  Выберите время для любой из доступных дат
                                </Typography>
                              )}
                            </Stack>
                            {serviceConfirm?.serviceId ? (
                              <Button
                                variant={"contained"}
                                loading={serviceConfirm.inProgress}
                                loadingIndicator={
                                  <Stack
                                    direction={"row"}
                                    spacing={1}
                                    sx={{
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Box>
                                      <CircularProgress
                                        size={"12px"}
                                        color={"gray"}
                                      />
                                    </Box>
                                    <Typography sx={{ fontSize: "12px" }}>
                                      Забронировать
                                    </Typography>
                                  </Stack>
                                }
                                sx={{
                                  // flex: '1 1 50%',
                                  fontSize: "12px",
                                  maxWidth: "300px",
                                  width: "100%",
                                }}
                                size={"large"}
                                onClick={() => {
                                  _handleServiceBook(serviceConfirm);
                                }}
                              >
                                Забронировать
                              </Button>
                            ) : (
                              <Button
                                variant={"contained"}
                                onClick={() => {
                                  datePlaceSection.current?.scrollIntoView({
                                    behavior: "smooth",
                                  });
                                }}
                                sx={{
                                  // flex: '1 1 50%',
                                  fontSize: "12px",
                                  maxWidth: "300px",
                                  width: "100%",
                                }}
                              >
                                Выбрать
                              </Button>
                            )}
                          </Stack>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Container>
              </ClickAwayListener>
            ) : null
          }
        />
      </Container>

      {/*helper components*/}
      <ChatModal
        open={chat.open}
        handleClose={handleChatClose}
        sxExtra={{
          minWidth: {
            xs: "90%",
            sm: "80%",
            md: "60%",
          },
          height: {
            xs: "90%",
            sm: "80%",
            md: "70%",
          },
          pl: 1,
        }}
      >
        <Container mixWidth={"md"} sx={{ height: "100%", minHeight: 0 }}>
          <Grid
            container
            minWidth={"md"}
            sx={{
              height: "100%",
              flexWrap: "nowrap",
            }}
            // sx={{
            //     backgroundColor: '#fff',
            //     minWidth: '80%',
            //     maxHeight: '80%',
            //     borderRadius: "20px",
            // }}
          >
            <Grid xs={4} sx={{ overflowY: "auto", height: "100%" }}>
              <Stack>
                {chat?.data?.length
                  ? chat?.data?.map((item) => (
                      <Card
                        // elevation={1}
                        // key={item.id}
                        // sx={{display: 'flex', '&:hover':  { border: '1px solid #2999ff'}, '&:focus': {outline: 'none'}}}
                        sx={{ border: "none" }}
                        onClick={() => {
                          setChatDetailed(item);
                          // handleServicePick(item);
                        }}
                      >
                        <CardActionArea
                          disableRipple
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                            alignItems: "flex-start",
                          }}
                          onClick={() => {
                            // handleServicePick(item)
                          }}
                        >
                          <CardMedia
                            component="img"
                            sx={{
                              width: 75,
                              height: 75,
                              p: 1,
                              borderRadius: "50%",
                              // ...(now() > item?.timeFrame?.to && {opacity: '0.5'})
                            }}
                            image={getImageV2(
                              item?.images?.map((im) => im.id)[0],
                            )}
                            alt=""
                          />
                          <CardContent
                            sx={{
                              display: "block",
                              flexGrow: 1,
                              alignSelf: "stretch",
                              borderBottom: "1px solid #e3e3e3",
                            }}
                          >
                            <Stack>
                              <Typography
                                align={"left"}
                                sx={{ color: "black" }}
                              >
                                {" "}
                                {item?.title}{" "}
                              </Typography>
                              <Typography
                                align={"left"}
                                sx={{ fontSize: "12px", color: "gray" }}
                              >
                                {" "}
                                {`Последнее собщение в чате`}{" "}
                              </Typography>
                            </Stack>

                            {
                              // now() > item?.timeFrame?.to ? <Typography sx={{fontSize: '12px'}} align={'left'}>прошедший </Typography> : null
                            }
                            {/*<Typography sx={{fontSize: '16px'}} align={'left'}> { item?.serviceTemplate?.title }</Typography>*/}
                          </CardContent>
                        </CardActionArea>
                      </Card>
                    ))
                  : null}
              </Stack>
            </Grid>
            <Grid xs={8} sx={{ overflowY: "auto", height: "100%" }}>
              {chatDetailed ? (
                <Box
                  sx={{
                    backgroundColor: "#fff",
                    overflow: "hidden",
                    height: "100%",
                  }}
                >
                  <Chat
                    sx={{ backgroundColor: "#fff", overflowY: "auto" }}
                    chatClientId={id}
                    messages={messages?.data?.map((m) => ({
                      id: m?.id,
                      text: m?.text,
                      sender: m?.clientId,
                    }))}
                    getMessages={() => {}}
                    addMessage={(text) => {
                      handleSendMessage(chatDetailed?.id, text);
                    }}
                  />
                </Box>
              ) : null}
            </Grid>
          </Grid>
        </Container>
      </ChatModal>
      <AuthModal open={authModal.open} handleClose={handleAuthModalClose}>
        <Stack
          spacing={3}
          sx={{ justifyContent: "center", alignItems: "center" }}
        >
          <Box
            sx={{ height: "30px" }}
            component={"img"}
            alt={"Логотип компании Bim"}
            src={BIM_LOGO}
          />
          <Typography component="h1" variant="h5">
            Войдите в аккаунт
          </Typography>
          <AuthBySMSForm
            setButton={setButton}
            setButtonClick={setButtonClick}
            onLoginSuccess={() => {
              setAuthModal((prevState) => ({ ...prevState, open: false }));
            }}
          />
        </Stack>
      </AuthModal>
      <FilterInfoV2
        open={filterInfo.open}
        handleClose={_handleFilterModalClose}
      >
        <Stack
          sx={{
            height: "100%",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ pb: 4 }}>
            <Typography
              align={"center"}
              sx={{ fontWeight: "bold", fontSize: "22px" }}
            >
              Фильтры
            </Typography>
          </Box>
          <Box sx={{ overflowY: "auto", height: "100%" }}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              sx={{
                pt: 1,
                pb: 1,
                pr: 1,
              }}
            >
              <CalendarMonthIcon sx={{ p: 2, color: "rgb(0 0 0/0.75)" }} />
              <Stack
                direction={"row"}
                sx={{
                  width: "100%",
                  // borderBottom: '1px solid rgb(0 0 0 / 0.1)',
                  pb: 1,
                }}
                alignItems={"center"}
                justifyContent={"space-between"}
              >
                <Stack
                  sx={{
                    flex: "1 1 auto",
                    justifyContent: "space-between",
                    "&:hover": {
                      cursor: "pointer",
                      backgroundColor: "rgb(0 0 0 / 0.01)",
                    },
                  }}
                  direction={"row"}
                  onClick={() => {
                    setFilterInfo((prevState) => ({
                      ...prevState,
                      calendar: {
                        ...prevState.calendar,
                        openFrom: !prevState?.calendar?.openFrom,
                        openTo: false,
                      },
                    }));
                    setShowCalendar((prevState) => !prevState);
                  }}
                >
                  <Stack>
                    <Typography
                      fontSize={"12px"}
                      sx={{ color: "rgb(0 0 0/ 0.7)" }}
                    >
                      С даты
                    </Typography>
                    <Typography>
                      {getDay(
                        _getValueFromFilter(
                          "timeFrameFrom",
                          filterInfo?.filters,
                        ),
                      )}
                    </Typography>
                  </Stack>
                  <ArrowForwardIosIcon
                    sx={{
                      p: 2,
                      color: "rgb(0 0 0/0.75)",
                      fontSize: "16px",
                      rotate: filterInfo.calendar.openFrom ? "90deg" : "none",
                    }}
                  />
                </Stack>
                <Stack
                  sx={{
                    flex: "1 1 auto",
                    justifyContent: "space-between",
                    "&:hover": {
                      cursor: "pointer",
                      backgroundColor: "rgb(0 0 0 / 0.01)",
                    },
                  }}
                  direction={"row"}
                  onClick={() => {
                    setFilterInfo((prevState) => ({
                      ...prevState,
                      calendar: {
                        ...prevState.calendar,
                        openTo: !prevState?.calendar?.openTo,
                        openFrom: false,
                      },
                    }));
                    setShowCalendar((prevState) => !prevState);
                  }}
                >
                  <Stack>
                    <Typography
                      fontSize={"12px"}
                      sx={{ color: "rgb(0 0 0/ 0.7)" }}
                    >
                      По дату
                    </Typography>
                    <Typography>
                      {getDay(
                        _getValueFromFilter("timeFrameTo", filterInfo?.filters),
                      )}
                    </Typography>
                  </Stack>
                  <ArrowForwardIosIcon
                    sx={{
                      p: 2,
                      color: "rgb(0 0 0/0.75)",
                      fontSize: "16px",
                      rotate: filterInfo.calendar.openTo ? "90deg" : "none",
                    }}
                  />
                </Stack>
              </Stack>
            </Stack>
            {filterInfo?.calendar?.openFrom ? (
              <LocalizationProvider
                dateAdapter={AdapterLuxon}
                adapterLocale={"ru"}
              >
                <StaticDatePicker
                  onChange={(newDate) => {
                    handleDatePickV2(newDate, "from");
                  }}
                  onClose={() => {
                    setFilterInfo((prevState) => ({
                      ...prevState,
                      calendar: { ...prevState?.calendar, openFrom: false },
                    }));
                  }}
                  views={["month", "day"]}
                  value={DateTime.fromSeconds(
                    _getValueFromFilter("timeFrameFrom", filterInfo?.filters),
                  )}
                  disablePast
                  maxDate={DateTime.fromSeconds(
                    _getValueFromFilter("timeFrameTo", filterInfo?.filters),
                  )}
                  slotProps={{
                    toolbar: {
                      hidden: true,
                    },
                  }}
                  slots={{
                    actionBar: () => null,
                  }}
                />
              </LocalizationProvider>
            ) : null}
            {filterInfo?.calendar?.openTo ? (
              <LocalizationProvider
                dateAdapter={AdapterLuxon}
                adapterLocale={"ru"}
              >
                <StaticDatePicker
                  onChange={(newDate) => {
                    handleDatePickV2(newDate, "to");
                  }}
                  onClose={() => {
                    setFilterInfo((prevState) => ({
                      ...prevState,
                      calendar: { ...prevState?.calendar, openTo: false },
                    }));
                  }}
                  views={["month", "day"]}
                  value={DateTime.fromSeconds(
                    _getValueFromFilter("timeFrameTo", filterInfo?.filters),
                  )}
                  disablePast
                  minDate={DateTime.fromSeconds(
                    _getValueFromFilter("timeFrameFrom", filterInfo?.filters),
                  )}
                  slotProps={{
                    toolbar: {
                      hidden: true,
                    },
                  }}
                  slots={{
                    actionBar: () => null,
                  }}
                />
              </LocalizationProvider>
            ) : null}
          </Box>

          <Box sx={{ p: 2 }}>
            <Stack
              direction={"row"}
              sx={{ justifyContent: "center" }}
              spacing={2}
            >
              <Button
                variant={"outlined"}
                onClick={() => {
                  setFilterInfo({ ...DEFAULT_FILTER_INFO_STATE, open: true });
                }}
                sx={{
                  flex: "1 1 auto",
                  maxWidth: "300px",
                }}
              >
                Сбросить
              </Button>
              <Button
                variant={"contained"}
                onClick={() => {
                  setFilters([...filterInfo.filters]);
                  setServices((prevState) => ({
                    ...prevState,
                    isLoaded: false,
                  }));
                  setFilterInfo((prevState) => ({ ...prevState, open: false }));
                }}
                sx={{
                  flex: "1 1 auto",
                  maxWidth: "300px",
                }}
              >
                Применить
              </Button>
            </Stack>
          </Box>
        </Stack>
      </FilterInfoV2>
    </App>
  );
}

export default MainScreen;
